import React, { useEffect, useState } from 'react'
import './header-2025.styles.scss'
import { Link, useLocation } from 'react-router-dom';
import eln_logo from '@/assets/elnlogo_wht.png';
import logo_wht from '@/assets/logo-wht.png';
import both_logos from '@/assets/both_logos.png';
import { useSelector } from 'react-redux';
import { version } from '../../changelog-version';

const Header2025 = ({
    platform,
    hideLinks
}) => {

    const currentUser = useSelector(state => state.userData.currentUser);
    const userProfile = useSelector(state => state.userData.userProfile);
    const dbData = useSelector(state => state.userData.dbData);
    const screenSize = useSelector(state => state.listsData.screenSize);
    const [ showDropdown, setShowDropdown ] = useState(false);
    const [ returnUrl, setReturnUrl ] = useState(null);
    const location = useLocation();

    useEffect(() => {
        let href = window.location.origin
        // console.log(window.location)
        let encoded = encodeURIComponent(href  + `/sso/?token={token}&intendedurl=%2Fhome%2F`)
        // console.log(encoded)
        setReturnUrl(`https://eweb.ilprincipals.org/eweb/?Site=ipa&WebCode=LoginRequired&expires=yes&URL_success=${encoded}`)
    },[window, setReturnUrl])

    return (
        <div className={`header-2025 ${
            (
                location.pathname.includes('/admin') || 
                (
                    platform === 'eln' || 
                    platform === 'ipa'
                ) && 
                !location.pathname.includes('/eval/')
            ) 
                ? '' 
                : 'no_source'
        } ${screenSize}`}>
            
            <div className='header_logo_and_title'>
                <div className='flex-row'>
                    {
                        (platform && platform === 'ipa') 
                        ?
                        <div><img 
                            className={`header_logo ${screenSize}`} 
                            src={logo_wht} 
                            alt='Illinois Principals Association' 
                            title='Illinois Principals Association' />
                        </div>
                        :
                        (platform && platform === 'eln')
                        ?
                        <div><img 
                            className={`header_logo ${screenSize}`} 
                            src={eln_logo} 
                            alt='EdLeaders Network' 
                            title='EdLeaders Network' />

                        </div>
                        :
                        <div><img 
                            className={`header_logo ${screenSize}`}
                            src={both_logos} 
                            alt='IPA and ELN' 
                            title='IPA and ELN' />
                        </div>
                    }
                    
                    <div className='header_title'>
                        {
                            (platform && platform === 'ipa') 
                            ? 'IPA Evaluations'
                            : 
                            (platform && platform === 'eln')
                            ? 'ELN Evaluations'
                            : 
                            (window.location.href.includes('/admin'))
                            ? 'IPA/ELN Eval Admin'
                            : 'IPA/ELN Evaluation Portal'
                        }
                    </div>
                </div>
                {
                    (hideLinks)
                    ?
                    <div></div>
                    :
                    <div className='header_links'>
                        {
                            (currentUser)
                            ?
                                <Link className='uk-link-reset' to='/home'>	
                                    <div className='header_menu_item allcaps' >
                                        Home
                                    </div>
                                </Link>
                                : ''
                        }
                            {
                                (dbData && dbData.Admin) 
                                ?
                                <Link className='uk-link-reset' to='/admin'>	
                                    <div className='header_menu_item allcaps' >
                                        Admin
                                    </div>
                                </Link>
                                
                                : ''
                            }
                        
                        <div className="menu_spacer"></div>
                        
                        {
                            (userProfile && currentUser)
                            ?
                            // <Link className='uk-link-reset' to='/logout'>	
                                <div className='header_menu_item allcaps clickable' 
                                    onClick={() => setShowDropdown(!showDropdown)}>
                                    {userProfile.fName} {userProfile.lName}
                                </div>
                            // </Link>
                            :
                            (returnUrl)	
                            ?
                            <a className='uk-link-reset' href={returnUrl}>	
                                <div className='header_menu_item allcaps' >
                                    Login
                                </div>
                            </a>
                            : ''
                        }
                        {
                            (showDropdown || !showDropdown) &&
                            <div className={`header_dropdown_menu_container ${showDropdown ? 'active' : ''}`}>
                                <div className='dropdown-menu'>
                                    <Link to="/logout">Logout</Link>
                                    <div className="g-space-1"></div>
                                    <div className='meta'>{version}</div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default Header2025;